import { useState, useEffect } from 'react';

/**
 * Même critère « mobile profil » que la Centrale Prysma (fiche comportementale) :
 * iPhone, iPad, iPod, Android — pour masquer l’entrée Centre d’aide dans le menu profil.
 */
export const isCentraleProfileMobileUa = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || window.opera || '';
  return /iPhone|iPad|iPod|Android/i.test(ua);
};

/**
 * Hook pour détecter le type d'appareil de l'utilisateur
 * @returns {Object} { isMobile, isDesktop, deviceType, isCentraleProfileMobile }
 */
const useDeviceType = () => {
  const [deviceInfo, setDeviceInfo] = useState({
    isMobile: false,
    isDesktop: true,
    deviceType: 'desktop',
    isCentraleProfileMobile: false,
  });

  useEffect(() => {
    const detectDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      // Détection des appareils mobiles (Android, iOS, etc.)
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|Mobile|Tablet/i;
      
      const isMobile = mobileRegex.test(userAgent);
      const isCentraleProfileMobile = /iPhone|iPad|iPod|Android/i.test(userAgent || '');
      
      // Déterminer le type d'appareil plus précisément
      let deviceType = 'desktop';
      
      if (/Android/i.test(userAgent)) {
        deviceType = 'android';
      } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        deviceType = 'ios';
      } else if (/Windows Phone|IEMobile|WPDesktop/i.test(userAgent)) {
        deviceType = 'windows-mobile';
      } else if (/Windows/i.test(userAgent)) {
        deviceType = 'windows';
      } else if (/Macintosh|Mac OS X/i.test(userAgent)) {
        deviceType = 'macos';
      } else if (/Linux/i.test(userAgent)) {
        deviceType = 'linux';
      }

      setDeviceInfo({
        isMobile,
        isDesktop: !isMobile,
        deviceType,
        isCentraleProfileMobile,
      });
    };

    detectDevice();

    // Écouter les changements de taille d'écran (rotation, etc.)
    window.addEventListener('resize', detectDevice);
    
    return () => {
      window.removeEventListener('resize', detectDevice);
    };
  }, []);

  return deviceInfo;
};

export default useDeviceType;
